import type { EntityValidationApi } from '@ipen-portal/backstage-plugin-entity-validation-backend';
import type { TRPCOptionsProxy } from '@trpc/tanstack-react-query';

import { createApiRef } from '@backstage/frontend-plugin-api';

export const entityValidationApiRef = createApiRef<
  TRPCOptionsProxy<EntityValidationApi>
>().with({
  id: 'plugin.ipen.entity.validation.api',
});
